<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
    >
      <template #items="{ item }">
        <td class="text-no-wrap cursor-pointer" @click="handleClickItem(item)">
          {{ item.beacon_id }}
        </td>
        <td class="text-no-wrap cursor-pointer" @click="handleClickItem(item)">
          {{ item.beacon_name || '-' }}
        </td>
        <td class="text-xs-right cursor-pointer" @click="handleClickItem(item)">
          {{ item.totalUsers }}
        </td>
        <td class="text-xs-right cursor-pointer" @click="handleClickItem(item)">
          {{ item.totalFriend }}
        </td>
        <td class="text-xs-right cursor-pointer" @click="handleClickItem(item)">
          {{ item.totalNonFriend }}
        </td>
        <td class="text-xs-right cursor-pointer" @click="handleClickItem(item)">
          {{ item.totalMessages }}
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        { text: 'Beacon ID', value: 'beacon_id' },
        { text: this.$t('name'), value: 'beacon_name' },
        { text: this.$t('total_user_receive_message'), value: 'totalUsers', align: 'right' },
        { text: 'Enter', value: 'totalFriend', align: 'right' },
        { text: 'Banner', value: 'totalNonFriend', align: 'right' },
        { text: this.$t('total messages'), value: 'totalMessages', align: 'right' }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: ''
      },
      rowsPerPageItems: [10, 25, 50, { text: this.$t('All'), value: -1 }]
    }
  },
  methods: {
    handleClickItem(item) {
      this.$emit('select', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/DataTable.vue